import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___init__impl__jj3mn23p0pea18kbfe7 as _ServerFile___init__impl__jj3mn2,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  HttpMethod_PUT_getInstance1ik48aaxkshw8 as HttpMethod_PUT_getInstance,
  RequestBodyFile26cfvm0aih79m as RequestBodyFile,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import {
  httpHeaders3s629sxokj9k6 as httpHeaders,
  fetch3uvmq4t9tt42y as fetch,
  mimeType31eog9gy5012s as mimeType,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { renderThumbnailOrNull3uya896byhc6g as renderThumbnailOrNull } from '../../../extensions/FileReference.ext.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isCharSequence1ju9jr1w86plq as isCharSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  ImageRemote256pcav1ipbca as ImageRemote,
  ImageLocal23zvpfzvp93up as ImageLocal,
  WordBreak_BreakAll_getInstance289x8dja79rdq as WordBreak_BreakAll_getInstance,
  ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { ProjectAttachmentv4m5lkl2nz8g as ProjectAttachment } from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  awaitqeg6zusi9ora as await_0,
  await1kke5zj2piplv as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  trim11nh7r46at6sx as trim,
  substringAfter1hku067gwr5ve as substringAfter,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { awaitNotNullzd1xp1uu2voc as awaitNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { ContractorDocument2jcw9hqg98amj as ContractorDocument } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { ImagePreviewSemantic_getInstance2vyufepdkqnqf as ImagePreviewSemantic_getInstance } from '../../theming/files.mjs';
import { get_outlinedfhcs63de0vzu as get_outlined } from '../../theming/appTheme.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { take9j4462mea726 as take } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { title1ahgushtajx2d as title } from '../../theming/Titles.mjs';
import { get_unpadded3gipn3ftxgnwh as get_unpadded } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  if (!($this.ogb_1.ngb_1 == null)) {
    var tmp = $this.ogb_1.kgb_1;
    return !((tmp == null ? null : new (ServerFile())(tmp)) == null);
  }
  var tmp_0 = $this.ogb_1;
  // Inline function 'com.lightningkite.now' call
  tmp_0.mgb_1 = get_default(Companion_instance).d1m();
  var file = $this.ogb_1.igb_1;
  var tmp_1;
  try {
    var tmp_2 = $this.pgb_1($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var upload = tmp_2;
    var tmp0 = upload.y4m_1;
    // Inline function 'com.lightningkite.kiteui.fetch' call
    var method = HttpMethod_PUT_getInstance();
    var headers = httpHeaders();
    var tmp_3 = fetch(tmp0, method, headers, new (RequestBodyFile())(file), VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_1 = _ServerFile___init__impl__jj3mn2(upload.z4m_1);
  } catch ($p) {
    var tmp_4;
    if ($p instanceof CancellationException()) {
      var e = $p;
      tmp_4 = null;
    } else {
      if ($p instanceof Exception()) {
        var e_0 = $p;
        tmp_4 = null;
      } else {
        throw $p;
      }
    }
    tmp_1 = tmp_4;
  }
  var uploadedFile = tmp_1;
  $this.ogb_1.kgb_1 = uploadedFile;
  var tmp_5 = $this.ogb_1;
  // Inline function 'com.lightningkite.now' call
  tmp_5.ngb_1 = get_default(Companion_instance).d1m();
  var tmp_6 = $this.ogb_1.kgb_1;
  return !((tmp_6 == null ? null : new (ServerFile())(tmp_6)) == null);
}
function *_generator_invoke__zhh2q8_0($this, $this$rememberSuspending, $completion) {
  if (!($this.qgb_1.ngb_1 == null)) {
    var tmp = $this.qgb_1.kgb_1;
    return !((tmp == null ? null : new (ServerFile())(tmp)) == null);
  }
  var tmp_0 = $this.qgb_1;
  // Inline function 'com.lightningkite.now' call
  tmp_0.mgb_1 = get_default(Companion_instance).d1m();
  var file = $this.qgb_1.igb_1;
  var tmp_1;
  try {
    var tmp_2 = $this.rgb_1($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var upload = tmp_2;
    var tmp0 = upload.y4m_1;
    // Inline function 'com.lightningkite.kiteui.fetch' call
    var method = HttpMethod_PUT_getInstance();
    var headers = httpHeaders();
    var tmp_3 = fetch(tmp0, method, headers, new (RequestBodyFile())(file), VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_1 = _ServerFile___init__impl__jj3mn2(upload.z4m_1);
  } catch ($p) {
    var tmp_4;
    if ($p instanceof CancellationException()) {
      var e = $p;
      tmp_4 = null;
    } else {
      if ($p instanceof Exception()) {
        var e_0 = $p;
        tmp_4 = null;
      } else {
        throw $p;
      }
    }
    tmp_1 = tmp_4;
  }
  var uploadedFile = tmp_1;
  var tmp_5;
  try {
    var tmp_6 = renderThumbnailOrNull(file, 300, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp0_safe_receiver = tmp_6;
    var tmp_7;
    if (tmp0_safe_receiver == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_8 = $this.rgb_1($completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var upload_0 = tmp_8;
      var tmp0_0 = upload_0.y4m_1;
      // Inline function 'com.lightningkite.kiteui.fetch' call
      var method_0 = HttpMethod_PUT_getInstance();
      var headers_0 = httpHeaders();
      var tmp_9 = fetch(tmp0_0, method_0, headers_0, new (RequestBodyFile())(tmp0_safe_receiver), VOID, VOID, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      tmp_7 = _ServerFile___init__impl__jj3mn2(upload_0.z4m_1);
    }
    tmp_5 = tmp_7;
  } catch ($p) {
    var tmp_10;
    if ($p instanceof CancellationException()) {
      var e_1 = $p;
      tmp_10 = null;
    } else {
      if ($p instanceof Exception()) {
        var e_2 = $p;
        tmp_10 = null;
      } else {
        throw $p;
      }
    }
    tmp_5 = tmp_10;
  }
  var uploadedPreview = tmp_5;
  $this.qgb_1.kgb_1 = uploadedFile;
  $this.qgb_1.lgb_1 = uploadedPreview;
  var tmp_11 = $this.qgb_1;
  // Inline function 'com.lightningkite.now' call
  tmp_11.ngb_1 = get_default(Companion_instance).d1m();
  var tmp_12 = $this.qgb_1.kgb_1;
  return !((tmp_12 == null ? null : new (ServerFile())(tmp_12)) == null);
}
var FilePreview$LocalFile$upload$slambdaClass;
function FilePreview$LocalFile$upload$slambda() {
  if (FilePreview$LocalFile$upload$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $uploader) {
        this.ogb_1 = this$0;
        this.pgb_1 = $uploader;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    FilePreview$LocalFile$upload$slambdaClass = $;
  }
  return FilePreview$LocalFile$upload$slambdaClass;
}
function FilePreview$LocalFile$upload$slambda_0(this$0, $uploader) {
  var i = new (FilePreview$LocalFile$upload$slambda())(this$0, $uploader);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var FilePreview$LocalFile$uploadAttachment$slambdaClass;
function FilePreview$LocalFile$uploadAttachment$slambda() {
  if (FilePreview$LocalFile$uploadAttachment$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $uploader) {
        this.qgb_1 = this$0;
        this.rgb_1 = $uploader;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    FilePreview$LocalFile$uploadAttachment$slambdaClass = $;
  }
  return FilePreview$LocalFile$uploadAttachment$slambdaClass;
}
function FilePreview$LocalFile$uploadAttachment$slambda_0(this$0, $uploader) {
  var i = new (FilePreview$LocalFile$uploadAttachment$slambda())(this$0, $uploader);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var RemoteAttachmentClass;
function RemoteAttachment() {
  if (RemoteAttachmentClass === VOID) {
    class $ {
      constructor(attachment) {
        this.sgb_1 = attachment;
      }
      toString() {
        return 'RemoteAttachment(attachment=' + toString(this.sgb_1) + ')';
      }
      hashCode() {
        return hashCode(this.sgb_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemoteAttachment()))
          return false;
        if (!equals(this.sgb_1, other.sgb_1))
          return false;
        return true;
      }
    }
    protoOf($).tgb = getImage;
    initMetadataForClass($, 'RemoteAttachment', VOID, VOID, [FilePreview()]);
    RemoteAttachmentClass = $;
  }
  return RemoteAttachmentClass;
}
var RemoteFileClass;
function RemoteFile() {
  if (RemoteFileClass === VOID) {
    class $ {
      constructor(location) {
        this.ugb_1 = location;
      }
      toString() {
        return 'RemoteFile(location=' + this.ugb_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.ugb_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemoteFile()))
          return false;
        if (!(this.ugb_1 === other.ugb_1))
          return false;
        return true;
      }
    }
    protoOf($).tgb = getImage;
    initMetadataForClass($, 'RemoteFile', VOID, VOID, [FilePreview()]);
    RemoteFileClass = $;
  }
  return RemoteFileClass;
}
var LocalFileClass;
function LocalFile() {
  if (LocalFileClass === VOID) {
    class $ {
      constructor(value) {
        this.igb_1 = value;
        this.jgb_1 = Signal().fak(new (Constant())(_Constant___init__impl__v45mub(null)));
        this.kgb_1 = null;
        this.lgb_1 = null;
        this.mgb_1 = null;
        this.ngb_1 = null;
      }
      vgb() {
        return this.jgb_1;
      }
      f52() {
        this.mgb_1 = null;
        this.ngb_1 = null;
      }
      wgb(uploader, $completion) {
        this.jgb_1.mam(new (Constant())(_Constant___init__impl__v45mub(null)));
        var tmp = this.jgb_1;
        tmp.mam(rememberSuspending(VOID, VOID, VOID, FilePreview$LocalFile$upload$slambda_0(this, uploader)));
      }
      xgb(uploader, $completion) {
        this.jgb_1.mam(new (Constant())(_Constant___init__impl__v45mub(null)));
        var tmp = this.jgb_1;
        tmp.mam(rememberSuspending(VOID, VOID, VOID, FilePreview$LocalFile$uploadAttachment$slambda_0(this, uploader)));
      }
      toString() {
        return 'LocalFile(value=' + toString(this.igb_1) + ')';
      }
      hashCode() {
        return hashCode(this.igb_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LocalFile()))
          return false;
        if (!equals(this.igb_1, other.igb_1))
          return false;
        return true;
      }
    }
    protoOf($).tgb = getImage;
    initMetadataForClass($, 'LocalFile', VOID, VOID, [FilePreview()], [1]);
    LocalFileClass = $;
  }
  return LocalFileClass;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      toString() {
        return 'Empty';
      }
      hashCode() {
        return -836142170;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Empty()))
          return false;
        return true;
      }
    }
    protoOf($).tgb = getImage;
    initMetadataForObject($, 'Empty', VOID, VOID, [FilePreview()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
function getImage() {
  var tmp;
  if (equals(this, Empty_instance)) {
    tmp = null;
  } else {
    if (this instanceof LocalFile()) {
      tmp = new (ImageLocal())(this.igb_1);
    } else {
      if (this instanceof RemoteAttachment()) {
        var tmp1_safe_receiver = this.sgb_1.h93();
        var tmp_0;
        var tmp_1 = tmp1_safe_receiver;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp1_safe_receiver);
        }
        var tmp2_elvis_lhs = tmp_0;
        tmp = new (ImageRemote())(tmp2_elvis_lhs == null ? _ServerFile___get_location__impl__ddyqaq(this.sgb_1.g93()) : tmp2_elvis_lhs);
      } else {
        if (this instanceof RemoteFile()) {
          tmp = new (ImageRemote())(this.ugb_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  return tmp;
}
var FilePreviewClass;
function FilePreview() {
  if (FilePreviewClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FilePreview');
    FilePreviewClass = $;
  }
  return FilePreviewClass;
}
function uploadAll(_this__u8e3s4, uploader, $completion) {
  return coroutineScope(uploadAll$slambda_0(_this__u8e3s4, uploader), $completion);
}
var FileDataClass;
function FileData() {
  if (FileDataClass === VOID) {
    class $ {
      constructor(id, name, preview, original) {
        id = id === VOID ? Companion_getInstance().m2p() : id;
        original = original === VOID ? null : original;
        this.ygb_1 = id;
        this.zgb_1 = name;
        this.agc_1 = preview;
        this.bgc_1 = original;
      }
    }
    initMetadataForClass($, 'FileData');
    FileDataClass = $;
  }
  return FileDataClass;
}
function *_generator_resolveProjectAttachments__1odmpd(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var p = element.agc_1;
    var tmp;
    if (p instanceof LocalFile()) {
      var tmp_0 = await_1(p.vgb(), $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var tmp_1 = awaitNotNull(tmp_0, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var uploaded = tmp_1;
      var tmp_2;
      if (uploaded) {
        var tmp0_safe_receiver = p.kgb_1;
        var tmp_3;
        var tmp_4 = tmp0_safe_receiver;
        if ((tmp_4 == null ? null : new (ServerFile())(tmp_4)) == null) {
          tmp_3 = null;
        } else {
          var tmp_5 = tmp0_safe_receiver;
          // Inline function 'kotlin.let' call
          var mainFile = (tmp_5 == null ? null : new (ServerFile())(tmp_5)).n2n_1;
          var tmp_6 = await_0(element.zgb_1, $completion);
          if (tmp_6 === get_COROUTINE_SUSPENDED())
            tmp_6 = yield tmp_6;
          tmp_3 = new (ProjectAttachment())(tmp_6, mimeType(p.igb_1), mainFile, p.lgb_1);
        }
        tmp_2 = tmp_3;
      } else {
        tmp_2 = null;
      }
      tmp = tmp_2;
    } else {
      if (p instanceof RemoteAttachment()) {
        var tmp_7 = await_0(element.zgb_1, $completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
        // Inline function 'kotlin.text.trim' call
        var this_0 = tmp_7;
        var tmp$ret$2 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        tmp = new (ProjectAttachment())(tmp$ret$2, p.sgb_1.f93(), p.sgb_1.g93(), p.sgb_1.h93());
      } else {
        if (p instanceof RemoteFile()) {
          tmp = new (ProjectAttachment())('', '', _ServerFile___init__impl__jj3mn2(p.ugb_1), null);
        } else {
          if (equals(p, Empty_instance)) {
            tmp = null;
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var tmp0_safe_receiver_0 = tmp;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver_0);
    }
  }
  return destination;
}
function resolveProjectAttachments(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_resolveProjectAttachments__1odmpd.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_resolveContractorDocuments__akskb3(_this__u8e3s4, contractor, $completion) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var p = element.agc_1;
    var tmp;
    if (p instanceof LocalFile()) {
      var tmp_0 = await_1(p.vgb(), $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var tmp_1 = awaitNotNull(tmp_0, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var uploaded = tmp_1;
      var tmp_2;
      if (uploaded) {
        var tmp0_safe_receiver = p.kgb_1;
        var tmp_3;
        var tmp_4 = tmp0_safe_receiver;
        if ((tmp_4 == null ? null : new (ServerFile())(tmp_4)) == null) {
          tmp_3 = null;
        } else {
          var tmp_5 = tmp0_safe_receiver;
          // Inline function 'kotlin.let' call
          var mainFile = (tmp_5 == null ? null : new (ServerFile())(tmp_5)).n2n_1;
          var tmp_6 = await_0(element.zgb_1, $completion);
          if (tmp_6 === get_COROUTINE_SUSPENDED())
            tmp_6 = yield tmp_6;
          tmp_3 = new (ContractorDocument())(element.ygb_1, contractor, tmp_6, mimeType(p.igb_1), mainFile, p.lgb_1);
        }
        tmp_2 = tmp_3;
      } else {
        tmp_2 = null;
      }
      tmp = tmp_2;
    } else {
      if (p instanceof RemoteAttachment()) {
        var tmp_7 = await_0(element.zgb_1, $completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
        // Inline function 'kotlin.text.trim' call
        var this_0 = tmp_7;
        var tmp$ret$2 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        tmp = new (ContractorDocument())(element.ygb_1, contractor, tmp$ret$2, p.sgb_1.f93(), p.sgb_1.g93(), p.sgb_1.h93());
      } else {
        if (p instanceof RemoteFile()) {
          tmp = new (ContractorDocument())(element.ygb_1, contractor, '', '', _ServerFile___init__impl__jj3mn2(p.ugb_1), null);
        } else {
          if (equals(p, Empty_instance)) {
            tmp = null;
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var tmp0_safe_receiver_0 = tmp;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver_0);
    }
  }
  return destination;
}
function resolveContractorDocuments(_this__u8e3s4, contractor, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_resolveContractorDocuments__akskb3.bind(VOID, _this__u8e3s4, contractor), $completion);
}
function renderAttachmentImage(_this__u8e3s4, attachment) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var $this$frame = view;
  reactiveScope($this$frame, ($this$reactiveScope) => {
    $this$frame.zb9();
    var a = $this$reactiveScope.baj(attachment);
    renderAttachmentImage_0($this$frame, a);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
}
function renderAttachmentImage_0(_this__u8e3s4, attachment) {
  var tmp = attachment.h93();
  if (!((tmp == null ? null : new (ServerFile())(tmp)) == null)) {
    var tmp_0 = _this__u8e3s4.ibb(_this__u8e3s4.hbb(ImagePreviewSemantic_getInstance()), get_unpadded(_this__u8e3s4));
    // Inline function 'com.lightningkite.kiteui.views.direct.image' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (ImageView())(_this__u8e3s4);
    this_0.pda(ImageScaleType_Fit_getInstance());
    var tmp_1 = attachment.h93();
    this_0.oda(new (ImageRemote())(_ServerFile___get_location__impl__ddyqaq(ensureNotNull(tmp_1 == null ? null : new (ServerFile())(tmp_1)).n2n_1)));
    this_0.zba();
    _this__u8e3s4.jbb(tmp_0, this_0);
  } else {
    if (startsWith(attachment.f93(), 'image')) {
      var tmp_2 = _this__u8e3s4.ibb(_this__u8e3s4.hbb(ImagePreviewSemantic_getInstance()), get_unpadded(_this__u8e3s4));
      // Inline function 'com.lightningkite.kiteui.views.direct.image' call
      // Inline function 'kotlin.apply' call
      var this_1 = new (ImageView())(_this__u8e3s4);
      this_1.pda(ImageScaleType_Fit_getInstance());
      this_1.oda(new (ImageRemote())(_ServerFile___get_location__impl__ddyqaq(attachment.g93())));
      this_1.zba();
      _this__u8e3s4.jbb(tmp_2, this_1);
    } else {
      var tmp_3 = _this__u8e3s4.ibb(_this__u8e3s4.hbb(ImagePreviewSemantic_getInstance()), get_outlined(_this__u8e3s4));
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (Frame())(_this__u8e3s4.pc());
      var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
      var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
      _this__u8e3s4.ebb(p, view);
      var tmp_4 = get_centered(view);
      view.jbb(tmp_4, title(view, ($this$title) => {
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$9 = substringAfter(attachment.f93(), _Char___init__impl__6a9atx(47)).toUpperCase();
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = take(tmp$ret$9, 25);
        var tmp = $this$title.tb5_1;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_0 = '\xA0';
        } else {
          tmp_0 = value;
        }
        tmp.fbu(tmp_0);
        $this$title.zco(WordBreak_BreakAll_getInstance());
        return Unit_instance;
      }));
      _this__u8e3s4.fbb(p, view);
      _this__u8e3s4.jbb(tmp_3, view);
    }
  }
}
function *_generator_invoke__zhh2q8_1($this, $this$async, $completion) {
  var tmp = $this.cgc_1.xgb($this.dgc_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var uploadAll$slambda$slambdaClass;
function uploadAll$slambda$slambda() {
  if (uploadAll$slambda$slambdaClass === VOID) {
    class $ {
      constructor($it, $uploader) {
        this.cgc_1 = $it;
        this.dgc_1 = $uploader;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    uploadAll$slambda$slambdaClass = $;
  }
  return uploadAll$slambda$slambdaClass;
}
function uploadAll$slambda$slambda_0($it, $uploader) {
  var i = new (uploadAll$slambda$slambda())($it, $uploader);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var uploadAll$slambdaClass;
function uploadAll$slambda() {
  if (uploadAll$slambdaClass === VOID) {
    class $ {
      constructor($this_uploadAll, $uploader) {
        this.egc_1 = $this_uploadAll;
        this.fgc_1 = $uploader;
      }
      wah($this$coroutineScope, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.egc_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, uploadAll$slambda$slambda_0(item, this.fgc_1));
          destination.v(tmp$ret$0);
        }
        return awaitAll(destination, $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    uploadAll$slambdaClass = $;
  }
  return uploadAll$slambdaClass;
}
function uploadAll$slambda_0($this_uploadAll, $uploader) {
  var i = new (uploadAll$slambda())($this_uploadAll, $uploader);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
//region block: init
Empty_instance = new (Empty())();
//endregion
//region block: exports
export {
  FileData as FileDataw8niis0ucpno,
  Empty as Empty276q86o7r56ey,
  LocalFile as LocalFileyitm5ua4ch17,
  RemoteAttachment as RemoteAttachment3uyi4s0lht7h0,
  RemoteFile as RemoteFileu6zpetu3ge6n,
  renderAttachmentImage as renderAttachmentImagegfmiopcjvyci,
  renderAttachmentImage_0 as renderAttachmentImage20glz1emw24de,
  resolveContractorDocuments as resolveContractorDocumentsg17i59nppbn3,
  resolveProjectAttachments as resolveProjectAttachments1r3ylk2p3xmwv,
  uploadAll as uploadAllkv4v1vjrnv9u,
  Empty_instance as Empty_instance19pnqi35t6rfs,
};
//endregion

//# sourceMappingURL=attachmentFilePreview.mjs.map
